export const GET_STUDENT = '/student'
export const GET_STUDENT_CRED = '/auth/user-credentials'
export const GET_REPORTS = '/dashboard/get-region-status/'
export const GET_REPORTS_EXPORT = '/dashboard/get-region-status/export'

export const ACCEPTED_BY_SCHOOL = '/school/students-accept/'
export const ACCEPTED_BY_BEO = '/block/students-accept/'
export const REJECTED_BY_SCHOOL = '/school/students-reject/'
export const REJECTED_BY_BEO = '/block/students-reject/'

export const ALLOT_STUDENT = '/school/students-allot/'
export const NOT_ALLOT_STUDENT = '/school/students-notallot/'

export const CANCEL_REJECTION_SCHOOL = '/state/cancel-school-reject/'
export const CANCEL_REJECTION_BEO = '/state/cancel-block-reject/'
export const CANCEL_SCHOOL_ACCEPT = '/state/cancel-school-accept/'

export const GET_APPLICATION = "/student/get-details-by-reg-aadhar-dob"